import React, { ContextType, cloneElement, useMemo } from "react";
import { ScrollMenu, VisibilityContext } from "react-horizontal-scrolling-menu";

import { CarouselItem } from "./CarouselItem";
import { LeftArrow, RightArrow } from "./arrows";
import useDrag from "./hooks/useDrag";

type scrollVisibilityApiType = ContextType<typeof VisibilityContext>;
export interface ICarouselItem {
  itemId: string | number;
  onClick?: () => void;
  dragging?: boolean;
}

export interface ICarousel {
  className: string;
  children: React.ReactElement<ICarouselItem>[];
}

const Carousel = ({ className: carouselClassName, children }: ICarousel) => {
  const { dragStart, dragStop, dragMove, dragging } = useDrag();
  const handleDrag =
    ({ scrollContainer }: scrollVisibilityApiType) =>
    (ev: React.MouseEvent) =>
      dragMove(ev, (posDiff) => {
        if (scrollContainer.current) {
          scrollContainer.current.scrollLeft += posDiff;
        }
      });

  return (
    <div onMouseLeave={dragStop}>
      <ScrollMenu
        LeftArrow={LeftArrow}
        RightArrow={RightArrow}
        onMouseDown={() => dragStart}
        onMouseUp={() => dragStop}
        onMouseMove={handleDrag}
      >
        {React.Children.map(children, (child, key) => {
          const { itemId, onClick, ...props } = child.props;
          const item = cloneElement(child, { dragging });
          return (
            <CarouselItem
              itemId={itemId.toString()}
              className={`${carouselClassName}__item`}
            >
              {item}
            </CarouselItem>
          );
        })}
      </ScrollMenu>
    </div>
  );
};

export default Carousel;
